import { useSyncExternalStore } from 'react';
import {
  applyUpdate,
  dismissUpdate,
  getServiceWorkerUpdateSnapshot,
  subscribeToServiceWorkerUpdate,
} from '../registerServiceWorker';

export interface UseServiceWorkerUpdateResult {
  /** A newer build has finished downloading and is waiting for a reload. */
  updateReady: boolean;
  /** Reload has been pressed; the page is about to reload. */
  applying: boolean;
  /** Hand over to the new build and reload. */
  applyUpdate: () => void;
  /** Hide the banner for this update. A later deploy shows it again. */
  dismissUpdate: () => void;
}

/**
 * React view of the Service Worker update store owned by
 * src/registerServiceWorker.ts. The store does all the work (and is what
 * the registration lifecycle feeds); this only subscribes a component to it.
 */
export function useServiceWorkerUpdate(): UseServiceWorkerUpdateResult {
  const { ready, applying } = useSyncExternalStore(
    subscribeToServiceWorkerUpdate,
    getServiceWorkerUpdateSnapshot,
    getServiceWorkerUpdateSnapshot
  );
  return { updateReady: ready, applying, applyUpdate, dismissUpdate };
}

export default useServiceWorkerUpdate;
